export interface AccountInformation {
  accountId: string | null | undefined
  pukWhenChanged: string | null | undefined
  pukLetterCreated: string | null | undefined
  username: string | null | undefined
  email: string
  accountStatus: string
  idLevel: IdLevel
  termsOfUseConfirmationTime: string
  createTimestamp: string
  modifyTimestamp: string
  migrated: boolean
}

export interface AccountInformationLoggedOut {
  policyId: string
  accountId: string
  birthdate: string
}

export interface AccountManagementPartner {
  partnerAddresses: AccountManagementPartnerAddress[]
  person: Person
}

export interface AccountManagementPartnerAddress {
  address: PostalAddress
  partner?: AccountManagementPartner
  partnerAddressId: number
  partnerProxyIds: string[]
}

export interface CodeValuePair {
  code: string
  value: string
}

export interface CsrfResponse {
  headerName: string
  token: string
  parameterName: string
}

export const idLevels = ['ANONYMOUS', 'ADDRESS', 'IDENTIFICATION'] as const

/**
 * Interface für die Anfrage zur Einrichtung von Benutzeranmeldedaten
 */
export interface InitialCredentialsRequest {
  username: string
  password: string
  emailCode: string
  birthdate: string
  vsnr?: string
  newEmail?: string
  termsAndConditionsAccepted: boolean
}

export interface NaturalPersonName {
  salutation?: { code: string; value: string }
  firstName: string
  name: string
}

export interface Person {
  name: NaturalPersonName
}

export interface PostalAddress {
  country: CodeValuePair
  postCode: string
  street: string
  streetExtra: string
  city: string
}

export interface PukSmsResult {
  date: string
  time: string
  phoneNumber: string
}

export enum RequestUnlockCodeState {
  CHOICE = 'Choice',
  ADDRESS = 'Address',
  ENTRY_UNLOCKCODE = 'EntryUnlockCode',
  SEND_UNLOCKCODE_LETTER_SUCCESS = 'SendUnlockCodeLetterSuccess',
  SEND_UNLOCKCODE_LETTER_SUCCESS_ADDRESS_CHANGE = 'SendUnlockCodeLetterSuccessAddressChange',
  ACTIVATION_SUCCCESS_WITHOUT_UNLOCKCODE = 'ActivationSuccessWithoutUnlockCode',
  UNLOCK_CODE_EXISTS = 'UnlockCodeExists',
  ERROR_LETTER = 'ErrorLetter',
  ERROR_SMS_PHONENUMBER = 'ErrorSmsPhoneNumber',
  ERROR_SMS_EXCEED = 'ErrorSmsExceed',
  ERROR_SMS_OFFLINE = 'ErrorSmsOffline',
  MISSING_PARTNER_ADDRESS_ID = 'MissingPartnerAddressId'
}

export type IdLevel = (typeof idLevels)[number]
